import { render, staticRenderFns } from "./DeliveryNote.vue?vue&type=template&id=0b4dfeb8&scoped=true&"
import script from "./DeliveryNote.vue?vue&type=script&lang=js&"
export * from "./DeliveryNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4dfeb8",
  null
  
)

export default component.exports